import { heightUpdatedEvent } from '@guuru/chat-events-web';
import { CHAT_FLOW_STEPS, ChatAPI, getCurrentChat } from '@guuru/chat-web';

let HEIGHT = 0;

const IgnoreSteps = [
  CHAT_FLOW_STEPS.chatQuestion,
  CHAT_FLOW_STEPS.booting,
  CHAT_FLOW_STEPS.chatInit,
  CHAT_FLOW_STEPS.chatStart,
  CHAT_FLOW_STEPS.chatLoad,
];

const getElement = (selector) =>
  global.document.getElementsByClassName(selector)[0];

const getElementHeight = (selector) => getElement(selector)?.scrollHeight || 0;

const getComponentHeight = () => {
  const headerHeight = getElementHeight('chat-header-wrapper');
  const contentSectionHeight = getElementHeight('chat-content-section');
  const askAnotherQuestionHeight = getElementHeight('chat-message-bar');

  return (
    headerHeight +
    askAnotherQuestionHeight +
    (contentSectionHeight < 350 ? 350 : contentSectionHeight + 30)
  );
};

export default function (step = getCurrentChat().flowStep) {
  const channel = ChatAPI.storeRetrieveChannel();

  if (channel !== 'form') return;

  let prevHeight = HEIGHT;

  if (IgnoreSteps.includes(step)) {
    HEIGHT = 0;
    heightUpdatedEvent(0);
    return;
  }

  HEIGHT = getComponentHeight();

  const startTimeout = (timeout) => {
    setTimeout(() => {
      prevHeight = HEIGHT;
      HEIGHT = getComponentHeight();
      if (prevHeight < HEIGHT || step === CHAT_FLOW_STEPS.connectingExpert) {
        heightUpdatedEvent(HEIGHT);
      }
    }, timeout);
  };

  startTimeout(700);
  startTimeout(2000);

  if (prevHeight === HEIGHT) return;

  if (prevHeight < HEIGHT || step === CHAT_FLOW_STEPS.connectingExpert) {
    heightUpdatedEvent(HEIGHT);
  }
}
